import { legalEntitiesApi } from '../../../api/services/legalEnitities.service';
import { LegalEntity, NewLegalEntity } from '../../../types/interfaces';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setErrorNotification, setNotification } from '../../../app/store/notifications';
type PatchLegalEntityRequest = Partial<LegalEntity> & Pick<LegalEntity, 'id'>;

// Достаём первое читаемое сообщение из ответа DRF.
// DRF для ValidationError возвращает либо { detail: "..." },
// либо { field: ["msg1", ...] }, либо просто строку.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const extractApiMessage = (error: any, fallback: string): string => {
  const data = error?.response?.data;
  if (!data) return fallback;
  if (typeof data === 'string') return data;
  if (typeof data.detail === 'string') return data.detail;
  for (const key of Object.keys(data)) {
    const value = data[key];
    if (typeof value === 'string') return value;
    if (Array.isArray(value) && typeof value[0] === 'string') return value[0];
  }
  return fallback;
};

export const fetchAllLegalEntities = createAsyncThunk(
  'legalEntities/fetchAll',
  async (params: object = {}) => {
    const response = await legalEntitiesApi.getAllLegalEntities(params);
    return response.data;
  }
);

export const fetchLegalEntityById = createAsyncThunk(
  'legalEntities/fetchById',
  async (id: number) => {
    const response = await legalEntitiesApi.getLegalEntityById(id);
    return response.data;
  }
);

export const createLegalEntity = createAsyncThunk(
  'legalEntities/create',
  async (data: NewLegalEntity, { dispatch, rejectWithValue }) => {
    try {
      const response = await legalEntitiesApi.createLegalEntity(data);
      dispatch(setNotification('Юр.лицо успешно добавлено!'));
      return response.data;
    } catch (error) {
      dispatch(
        setErrorNotification(
          extractApiMessage(error, 'Ошибка при добавлении юр.лица')
        )
      );
      return rejectWithValue(error);
    }
  }
);

export const updateLegalEntity = createAsyncThunk(
  'legalEntities/update',
  async (data: LegalEntity, { dispatch, rejectWithValue }) => {
    try {
      const response = await legalEntitiesApi.updateLegalEntity(data.id, data);
      dispatch(setNotification('Юр.лицо успешно обновлено!'));
      return response.data;
    } catch (error) {
      dispatch(
        setErrorNotification(
          extractApiMessage(error, 'Ошибка при обновлении юр.лица')
        )
      );
      return rejectWithValue(error);
    }
  }
);

export const partialUpdateLegalEntity = createAsyncThunk(
  'legalEntities/partialUpdate',
  async (data: PatchLegalEntityRequest, { dispatch, rejectWithValue }) => {
    try {
      const response = await legalEntitiesApi.partialUpdateLegalEntity(
        data.id,
        data
      );
      dispatch(setNotification('Юр.лицо успешно обновлено!'));
      return response.data;
    } catch (error) {
      dispatch(setErrorNotification('Ошибка при добавлении юр.лица'));
      return rejectWithValue(error);
    }
  }
);

export const deleteLegalEntity = createAsyncThunk(
  'legalEntities/delete',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      await legalEntitiesApi.deleteLegalEntity(id);
      dispatch(setNotification('Юр.лицо успешно удалено!'));
      return id;
    } catch (error) {
      dispatch(setErrorNotification('Ошибка при удалении юр.лица'));
      return rejectWithValue(error);
    }
  }
);

